module.exports = __webpack_public_path__ + "media/images/slide-1-8b7a85fcb19598ed08714a90ed1fd367.png";